// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"V8-z"};